import type { DischargeType } from '@/types/DischargeRequest';
import { yupMixed, yupObject } from '../../yup';

export const dischargeRequestTypeSchema = yupObject({
  dischargeType: yupMixed<DischargeType>().oneOf(['full', 'partial']).required().label('Discharge type'),
});
